import { Box, Button, Typography } from "@mui/material";
import { FC } from 'react';
import { Link } from 'react-router-dom';

interface EventHeaderSectionProps {
    eventId: string;
    publicEventUrl: string | undefined;
    onCopyEventUrl: () => void;
}

const EventHeaderSection: FC<EventHeaderSectionProps> = ({
    eventId,
    publicEventUrl,
    onCopyEventUrl
}) => {
    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h2" component="h2" gutterBottom>
                {eventId.toLowerCase() === 'new' ? 'Create New Event' : 'Edit Event Details'}
            </Typography>
            {publicEventUrl !== undefined && (
                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                    <Button
                        onClick={onCopyEventUrl}
                        variant='contained'
                        size="small"
                    >
                        Copy Event URL
                    </Button>
                    <Button
                        component={Link}
                        to={publicEventUrl}
                        target='_blank'
                        variant='contained'
                        size="small"
                    >
                        View Live Event
                    </Button>
                </Box>
            )}
        </Box>
    );
};

export default EventHeaderSection;
